<script lang="ts" setup>
import { Spinner } from '@vue-interface/activity-indicator';
import { BtnActivity } from '@vue-interface/btn-activity';

withDefaults(defineProps<{
    form?: { processing?: boolean }
    submit?: () => void;
    activity?: boolean;
    disabled?: boolean;
    buttonLabel?: string;
    buttonBlock?: boolean;
    // Extra classes for the submit row, so a page can constrain it to the same
    // width as its content instead of the full page.
    buttonRowClass?: string;
}>(), {
    form: () => ({}),
    activity: false,
    disabled: false,
    buttonBlock: false,
    buttonLabel: 'Submit',
    buttonRowClass: '',
    submit: () => {}
});
</script>

<template>
    <form @submit.prevent="() => submit()">
        <div class="flex flex-col gap-y-5">
            <div>
                <slot />
            </div>
  
            <div
                class="flex justify-end"
                :class="buttonRowClass">
                <slot
                    name="button">
                    <BtnActivity
                        type="submit"
                        variant="btn-primary"
                        :block="buttonBlock"
                        :indicator="Spinner"
                        :activity="activity || form?.processing"
                        :disabled="disabled || form?.processing">
                        {{ buttonLabel }}
                    </BtnActivity>
                </slot>
            </div>
        </div>
    </form>
</template>